import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import clientService from "../../services/client/clientService";
import UploadModules from "../../constants/uploadModules";


export default function ClientForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        clientName: "",
        logo: "",
        website: "",
        displayOrder: 0,
        isActive: true

    });

    useEffect(() => {

        if (isEdit) {

            loadClient();

        }

    }, []);

    const loadClient = async () => {

        try {

            setLoading(true);

            const response = await clientService.getById(id);
            const data = response.data;

            if (response.success) {

                const data = response.data;

                setForm({

                    clientName: data.clientName || "",
                    logo: data.logo || "",
                    website: data.website || "",
                    displayOrder: data.displayOrder || 0,
                    isActive: data.isActive

                });

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();
        if (!form.clientName.trim()) {

            toast.error("Client Name is required.");

            return;

        }

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await clientService.update(id, form);

            }
            else {

                response = await clientService.create(form);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/clients");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit Client" : "Add Client"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">

                            <div className="col-lg-6">

                                <label className="form-label">
                                    Client Name <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="clientName"
                                    value={form.clientName}
                                    onChange={handleChange}
                                />

                            </div>
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Website
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="website"
                                    value={form.website}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Image */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Logo
                                </label>

                                <ImageUploader
                                    module={UploadModules.CLIENT}
                                    value={form.logo}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            logo: path
                                        })
                                    }
                                />

                            </div>


                            {/* Status */}
                            <div className="col-lg-2 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/clients")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}